module.exports = __webpack_public_path__ + "static/media/gamania.9af872fe.webp";